import { render, staticRenderFns } from "./pengajuan.vue?vue&type=template&id=38b280f8&"
import script from "./pengajuan.vue?vue&type=script&lang=js&"
export * from "./pengajuan.vue?vue&type=script&lang=js&"
import style0 from "./pengajuan.vue?vue&type=style&index=0&id=38b280f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports